import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'src/app/domains/companies/models';
import { SupportDevice } from 'src/app/domains/support-devices/models';
import { SupportDevicesService } from 'src/app/domains/support-devices/services';
import { User } from 'src/app/domains/users/models';
import { UsersService } from 'src/app/domains/users/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';

@Component({
  selector: 'gdp-company-support-devices',
  templateUrl: './company-support-devices.component.html',
  styleUrls: ['./company-support-devices.component.scss']
})
export class CompanySupportDevicesComponent implements OnInit {
  @Input() company: Company;
  public devices: SupportDevice[] = [];
  public loading: boolean = false;
  public loadingLine: boolean = false;

  constructor(
    private supportDevicesService: SupportDevicesService,
    private usersService: UsersService,
    private notification: NotificationService,
    private translateService: TranslateService,
    private utilsService: UtilsService
    ) {}

  ngOnInit() {
    this.getUsersDevices();
  }

  getUsersDevices() {
    this.loading = true;
    this.usersService.getUsers(this.company.companyId).subscribe((res: any) => {
      const users: User[] = res;
      users.forEach((user: User) => {
        let supportDevice: SupportDevice = {
          userId: user.pbxId,
          first_name: user.firstName,
          last_name: user.lastName,
          extension: user.extension,
          deviceId: null,
          username: null,
          password: null,
          type: null
        };
        this.supportDevicesService.getDevices(this.company.pbxId, user.pbxId).subscribe((devices: SupportDevice[]) => {
          devices.forEach((device: any) => {
            if (device.type === 'SUPPORT') {
              supportDevice.username = device.username;
              supportDevice.password = device.password;
              supportDevice.deviceId = device.id;
            }
          });
          this.devices.push(supportDevice);
          this.loading = false;
        }, () => {
          this.loading = false;
        });
      });
    }, () => {
      this.loading = false;
    });
  }

  onCreateDevice(device: SupportDevice, index: number) {
    device._isLoading = true;
    this.supportDevicesService.createDevice(this.company.pbxId, device.userId).subscribe((res: any) => {
      this.devices[index].deviceId = res.id;
      this.devices[index].username = res.username;
      this.devices[index].password = res.password;
      this.notification.success('company.support-devices.success-create');
      device._isLoading = false;
    }, () => {
      device._isLoading = false;
    });
  }

  onDeleteDevice(device: SupportDevice, index: number) {
    this.notification.showConfirmation('company.support-devices.confirm-delete').then((result: string) => {
      if (result === 'ok') {
        device._isLoading = true;
        this.supportDevicesService.deleteDevice(this.company.pbxId, device.userId, device.deviceId).subscribe((res: any) => {
          this.devices[index].username = null;
          this.devices[index].password = null;
          this.devices[index].deviceId = null;
          this.notification.success('company.support-devices.success-delete');
          device._isLoading = false;
        }, () => {
          device._isLoading = false;
        });
      }
    });
  }

  onCopy(text: string, fieldName: string) {
    this.utilsService.copyToClipboard(
      text,
      'text/plain',
      () => {
      this.notification.success(this.translateService.instant('company.support-devices.success-copy', {name: fieldName}));
    });
  }

}
